import { ResetPasswordInput } from '../../lib/types/models/auth/reset-password'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function resetPassword(data: ResetPasswordInput) {
  return restApiClient
    .url(constructApiUrl(API.auth.resetPassword.url, null))
    .post<never, ResetPasswordInput>(data)
}
